/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../_metronic/_helpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  { editUser, saveUser, isEdit, processing, setisEdit, openDeleteAdminDialog }
) => {

  const callEditFunction = async (row) => {
    editUser(row);
  }
  const callSaveUserFunction = async (row) => {
    saveUser(row);
  }
  const callCancelButtonFunction = async () => {
    setisEdit('');
  }

  if(isEdit === row.id)
  {
    if(processing === "save"+row.id)
    {
      return (<i className="fas fa-circle-notch fa-spin"></i>)
    }
    else
    {
      return (
        <>
          <button type="button" className="btn btn-primary" onClick={()=>callSaveUserFunction(row)}>Save</button>
          <button type="button" className="btn btn-danger ml-1" onClick={()=>callCancelButtonFunction()}>Cancel</button>
        </>
      )
    }
  }
  else
  {
  return  (
    <>
      <OverlayTrigger
        overlay={<Tooltip id="users-edit-tooltip">Edit admin</Tooltip>}
      >
        <a
          href="#"
          className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
          onClick={(e) => { e.preventDefault(); callEditFunction(row); }}
        >
          <span className="svg-icon svg-icon-md svg-icon-primary">
            <SVG
              src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
            />
          </span>
        </a>
      </OverlayTrigger>

      {openDeleteAdminDialog && (
        <OverlayTrigger
          overlay={<Tooltip id="admins-delete-tooltip">Delete admin</Tooltip>}
        >
          <a
            href="#"
            className="btn btn-icon btn-light btn-hover-danger btn-sm"
            onClick={(e) => { e.preventDefault(); openDeleteAdminDialog(row.id); }}
          >
            <span className="svg-icon svg-icon-md svg-icon-danger">
              <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
            </span>
          </a>
        </OverlayTrigger>
      )}
    </>
  )
  }
}
